"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _dotUtils = require("dot-utils");

var _ramda = require("ramda");

var _Input = _interopRequireDefault(require("./Input"));

var _reactUse = require("react-use");

var _Clickable = _interopRequireDefault(require("../elements/Clickable"));

var _Wrapper = _interopRequireDefault(require("../elements/Wrapper"));

var _styles = require("../styles");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _StyledWrapper = (0, _styledComponents["default"])(_Wrapper["default"]).withConfig({
  displayName: "Select___StyledWrapper",
  componentId: "sc-1azre7t-0"
})(["display:inline-block;position:relative;"]);

var _StyledWrapper2 = (0, _styledComponents["default"])(_Wrapper["default"]).withConfig({
  displayName: "Select___StyledWrapper2",
  componentId: "sc-1azre7t-1"
})(["position:relative;"]);

var _StyledInput = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "Select___StyledInput",
  componentId: "sc-1azre7t-2"
})(["cursor:pointer;user-select:none;"]);

var _StyledWrapper3 = (0, _styledComponents["default"])(_Wrapper["default"]).withConfig({
  displayName: "Select___StyledWrapper3",
  componentId: "sc-1azre7t-3"
})(["position:absolute;right:", "px;", ";"], _styles.baseSpacing, _styles.centerY);

var _StyledWrapper4 = (0, _styledComponents["default"])(_Wrapper["default"]).withConfig({
  displayName: "Select___StyledWrapper4",
  componentId: "sc-1azre7t-4"
})(["box-shadow:", ";position:absolute;top:100%;"], _styles.boxShadow);

var _StyledClickable = (0, _styledComponents["default"])(_Clickable["default"]).withConfig({
  displayName: "Select___StyledClickable",
  componentId: "sc-1azre7t-5"
})(["transition:0.2s ", ";&:hover{background-color:", ";}"], _styles.easing, function (p) {
  return p._css;
});

function Select(_ref) {
  var options = _ref.options,
      value = _ref.value,
      multiple = _ref.multiple,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
      placeholder = _ref.placeholder,
      props = _objectWithoutProperties(_ref, ["options", "value", "multiple", "onChange", "onBlur", "placeholder"]);

  var ref = (0, _react.useRef)(null);

  var _useStateEffect = (0, _dotUtils.useStateEffect)((0, _dotUtils.ensureArray)(value)),
      _useStateEffect2 = _slicedToArray(_useStateEffect, 2),
      stateValue = _useStateEffect2[0],
      setStateValue = _useStateEffect2[1];

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var handleOptionClick = function handleOptionClick(value) {
    var newValue;

    if (multiple) {
      newValue = (0, _ramda.symmetricDifference)(stateValue, [value]);
    } else {
      if (stateValue.includes(value)) {
        newValue = [];
      } else {
        newValue = [value];
      }
    }

    setStateValue(newValue);
    onChange({
      target: {
        value: newValue
      }
    });
  };

  (0, _reactUse.useClickAway)(ref, function () {
    if (isOpen) {
      setIsOpen(false);
    }

    onBlur({
      target: {
        value: stateValue
      }
    });
  });
  var formattedValue = stateValue.reduce(function (acc, val, index) {
    var _options$find;

    if (index > 0) {
      acc += ', ';
    }

    acc += (_options$find = options.find((0, _ramda.propEq)('value', val))) === null || _options$find === void 0 ? void 0 : _options$find.label;
    return acc;
  }, '');
  return /*#__PURE__*/_react["default"].createElement(_StyledWrapper, _extends({
    ref: ref
  }, (0, _ramda.omit)(['type', 'children'], props)), /*#__PURE__*/_react["default"].createElement(_StyledWrapper2, null, /*#__PURE__*/_react["default"].createElement(_StyledInput, {
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    type: 'text',
    readOnly: true,
    value: formattedValue,
    placeholder: placeholder,
    width: '100%',
    pr: _styles.baseSpacing * 2
  }), /*#__PURE__*/_react["default"].createElement(_StyledWrapper3, null, "\u25BC")), isOpen && /*#__PURE__*/_react["default"].createElement(_StyledWrapper4, {
    background: 'white',
    width: '100%'
  }, options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_StyledClickable, {
      key: option.value,
      py: 10,
      px: 10,
      background: stateValue.includes(option.value) ? _styles.grey : 'transparent',
      fontSize: _styles.fontSizes.body,
      onClick: function onClick() {
        return !option.disabled && handleOptionClick(option.value);
      },
      _css: !option.disabled && _styles.grey
    }, /*#__PURE__*/_react["default"].createElement(_Wrapper["default"], {
      component: 'span',
      opacity: option.disabled ? 0.4 : 1
    }, option.label));
  })));
}

var _default = Select;
exports["default"] = _default;